<template>
  <div class="pub-home">
    <div class="main">
      <div class="main-header" slot="header">
        <h3>通知公告</h3>
        <el-button type="primary" @click.native.prevent="close" class="right-top-close">
          <i class="el-icon-close"></i>
        </el-button>
      </div>

      <div class="main-body">
        <el-table
          :data="list"
          v-loading="listLoading"
          style="margin: 0 30px;width: auto;cursor: pointer;"
          @row-click="rowClick"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="sendTime" label="发布时间">
            <template slot-scope="scope">{{
              scope.row.sendTime | formatDateTime
            }}</template>
          </el-table-column>
        </el-table>
      </div>

      <!-- <div class="btns">
        <el-button
          type="primary"
          @click.native.prevent="close"
        >
          关闭
        </el-button>
      </div> -->
    </div>
    <template v-if="showpub">
      <PubInfo :notice="noticeRow" @cancel="closewindow"> </PubInfo
    ></template>
  </div>
</template>

<script>
import { fetchList } from "@/api/notice";
import { formatDate } from "@/utils/date";
import PubInfo from "./PubInfo.vue";

export default {
  name: "Pub",
  props: {
      //default: ""
      empId: {
                type: String,
                default: ""
            },
  },
  data() {
    return {
      listQuery: {
        keyword: null,empId:'',
        pageNum: 1,
        pageSize: 10,
      },
      list: null,loading:false,
      total: null,
      listLoading: true,
      showpub: false,
      noticeRow: null,
    };
  },
  components: {
    PubInfo,
  },
  created() {
    this.init();
  },
  filters: {
    formatDateTime(time) {
      if (time == null || time === "") {
        return "N/A";
      }
      let date = new Date(time);
      return formatDate(date, "yyyy-MM-dd hh:mm:ss");
    },
    formatStatus(status) {
      if (status == 1) {
        return "启用";
      }
      return "停用";
    },
  },
  methods: {
    init() {
      this.listLoading = true;
      this.listQuery.empId=this.empId,
      fetchList(this.listQuery).then((response) => {
        this.listLoading = false;
        this.list = response.data.list;
        this.total = response.data.total;
        this.totalPage = response.data.totalPage;
        this.pageSize = response.data.pageSize;
      });
    },
    rowClick(row, column) {
      this.noticeRow = row;
      this.openwindow();
    },
    close() {
      this.$emit("cancel");
    },
    openwindow() {
      this.showpub = true;
    },
    closewindow() {
      this.showpub = false;
    },
  },
};
</script>

<style scoped>
.pub-home {
  width: 100vw;
  height: 100vh;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  left: 0;
  top: 0;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  background: #fff;
  position: relative;
  width: 1000px;
  min-height: 40vh;
  max-height: 90vh;
  text-align: center;
  border-radius: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.main-header{
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  z-index: 99;
}
.main-body{
  flex: 1;
  overflow-y: auto;
  margin-bottom: 30px;
}
.btns {
  background-color: #fff;
  box-shadow: 0 0 20px rgba(0,0,0,0.1);
  margin-top: auto;
  padding:20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
}
.right-top-close{
  position: absolute;
  right: 20px;
  background-color: #eee;
  color: #191919;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
}
.right-top-close:hover{
  background-color: #ddd;
}
</style>



// WEBPACK FOOTER //
// src/views/login/components/Pub.vue